import React from 'react';

const TechCoLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    data-testid="techcoLogo"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <g id="Artboard1" transform="matrix(0.8,0,0,1,0,0)">
      <rect x="0" y="0" width="250" height="50" style={{ fill: 'none' }} />
      <g transform="matrix(0.285774,0,0,0.228619,51.2889,13.6296)">
        <g>
          <g>
            <g>
              <path
                d="M107.36,28.5L133.85,28.5L116.85,45.5L107.35,45.5L107.35,74.63C107.35,80.72 110.18,82.7 115.56,82.7C117.511,82.719 119.459,82.531 121.37,82.14L121.37,97.71C117.974,98.96 114.367,99.537 110.75,99.41C97.16,99.41 88.66,91.34 88.66,77.89L88.66,4.61L107.35,4.61L107.36,28.5Z"
                style={{ fillRule: 'nonzero' }}
              />
              <path
                d="M191.84,77.33C188.3,89.33 177.26,99.42 160.13,99.42C141.02,99.42 124.13,85.68 124.13,62.18C124.13,39.96 140.55,25.52 158.39,25.52C179.91,25.52 192.79,39.25 192.79,61.62C192.79,64.31 192.51,67.14 192.51,67.42L142.71,67.42C143.14,76.62 150.93,83.28 160.27,83.28C169.05,83.28 173.86,78.89 176.12,72.66L191.84,77.33ZM174.28,54.54C174,47.6 169.47,40.81 158.71,40.81C148.94,40.81 143.56,48.17 143.14,54.54L174.28,54.54Z"
                style={{ fillRule: 'nonzero' }}
              />
              <path
                d="M216.71,62.47C216.71,75.07 224.92,82.14 234.55,82.14C244.18,82.14 248.99,75.77 250.55,70.39L267.11,75.92C263.99,87.52 253.11,99.42 234.55,99.42C214.02,99.42 197.88,83.84 197.88,62.47C197.88,41.1 213.74,25.52 234,25.52C253,25.52 263.73,37.27 266.7,49.02L249.86,54.68C248.16,48.88 243.77,42.93 234.43,42.93C224.78,42.93 216.71,49.87 216.71,62.47Z"
                style={{ fillRule: 'nonzero' }}
              />
              <path
                d="M291.21,99.42L272.38,99.42L272.38,19L291.38,0L291.18,35.57C295.71,30.19 303.36,27.93 310.01,27.93C327.71,27.93 335.92,40.24 335.92,55.53L335.92,99.42L317.12,99.42L317.12,58.79C317.12,51 313.3,44.91 304.24,44.91C296.31,44.91 291.64,50.91 291.24,58.5L291.21,99.42Z"
                style={{ fillRule: 'nonzero' }}
              />
              <path
                d="M355.71,73.64L355.72,73.64C362.791,73.64 368.61,79.459 368.61,86.53C368.61,93.601 362.791,99.42 355.72,99.42C348.649,99.42 342.83,93.601 342.83,86.53C342.889,79.485 348.665,73.705 355.71,73.64Z"
                style={{
                  fill: 'rgb(30,185,213)',
                  fillRule: 'nonzero',
                }}
              />
              <path
                d="M390.16,62.47C390.16,75.07 398.37,82.14 408,82.14C417.63,82.14 422.44,75.77 424,70.39L440.56,75.92C437.45,87.52 426.56,99.42 408,99.42C387.47,99.42 371.33,83.84 371.33,62.47C371.33,41.1 387.19,25.52 407.43,25.52C426.43,25.52 437.16,37.27 440.14,49.02L423.29,54.68C421.59,48.88 417.2,42.93 407.86,42.93C398.23,42.93 390.16,49.87 390.16,62.47Z"
                style={{ fillRule: 'nonzero' }}
              />
              <path
                d="M515.87,62.47C515.87,83.84 500.16,99.47 479.35,99.47C458.54,99.47 442.82,83.89 442.82,62.52C442.82,41.15 458.54,25.57 479.35,25.57C500.16,25.57 515.87,41 515.87,62.47ZM497.04,62.47C497.04,49.3 488.55,42.65 479.35,42.65C470.15,42.65 461.65,49.3 461.65,62.47C461.65,75.47 470.15,82.29 479.35,82.29C488.55,82.29 497,75.63 497,62.47L497.04,62.47Z"
                style={{ fillRule: 'nonzero' }}
              />
              <path
                d="M18.7,4.55L0,23.23L51.32,23.23L51.31,74.52L69.99,55.79L69.99,4.56L18.7,4.55Z"
                style={{
                  fill: 'rgb(30,185,213)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default TechCoLogo;
